/*
 *                     NOTICE
 *        COPYRIGHT 2019 - 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * A union of all types of help available, to be used in menus and so on
 */

export const AB_WHATS_NEW = Symbol("AbWhatsNew");
export const AB_INITIO_HELP = Symbol("AbInitioHelp");
//# sourceMappingURL=IHelpService.js.map
